// monarch routes
export enum AppPath {
	Catalog = '/catalog',
	Home = '/',
	NotFound = '/404',
}

// monolith routes
export enum Route {
	AdminGiving = 'company/reports/giving',
	AdminAwards = '/admin/awards',
	AdminAwardsPending = 'admin/awards/pending',
	AdminBilling = '/company/billing',
	AdminBillingActivity = '/company/billing_activity',
	AdminConfigurations = 'company/settings/configuration/edit',
	AdminChanges = '/admin/security/data_change_logs',
	AdminCompanyChanges = '/admin/security/data_change_logs/company',
	AdminEarnings = '/company/accounts',
	AdminEmptyIntegration = '/company/integrations/user_managements',
	AdminImportedUsers = '/company/imported_users',
	AdminItems = '/company/catalog_items',
	AdminParticipation = '/company/users/participation',
	AdminRecognitionActivity = '/admin/reports/recognition-activity',
	AdminRewards = '/company/rewards?aasm_state=approved&range=all',
	AdminSecurity = '/admin/security/sign_in_logs',
	AdminSettings = '/company/settings/appearance/edit',
	AdminSpend = '/analytics/budget_utilization',
	AdminRedemptions = '/company/rewards/redemptions',
	AdminTotals = '/company/rewards/totals_report',
	AdminUsers = '/company/users',
	SuperAdminManageCompanies = '/super_admin/companies',
	SuperAdminUsageEvents = '/super_admin/companies/usage_events',
	SuperAdminCompanySignUps = '/super_admin/sign_up_activity',
	SuperAdminKyb = '/super_admin/kyb',
	SuperAdminInviteReport = '/super_admin/companies/invite_report',
	SuperAdminCompanyIntegrations = '/super_admin/integrations_dashboards',
	SuperAdminExternalIntegrations = '/super_admin/external_integrations',
	SuperAdminRenewalPriceIncreases = '/super_admin/renewal_price_increases',
	SuperAdminBillingStatus = '/super_admin/billing_status',
	SuperAdminManageUsers = '/super_admin/spoof/new',
	SuperAdminAliasUsers = '/super_admin/alias_users/new',
	SuperAdminPromos = '/super_admin/promos',
	SuperAdminManageRewards = '/super_admin/rewards',
	SuperAdminRewardsHealth = '/super_admin/rewards/health_check',
	SuperAdminTangoOrders = '/super_admin/tangocard_orders',
	SuperAdminManuallyFulfilled = '/super_admin/manually_fulfilled_rewards',
	SuperAdminManageCatalog = '/super_admin/items',
	SuperAdminProviders = '/super_admin/catalog/accounts',
	SuperAdminPublicBrands = '/super_admin/catalog/public_brands',
	SuperAdminOutOfStock = '/super_admin/catalog/out_of_stock',
	SuperAdminLint = '/super_admin/catalog/lint',
	SuperAdminUnimplemented = '/super_admin/catalog/unimplemented_brands',
	SuperAdminPromoted = '/super_admin/catalog/promoted',
	SuperAdminInternals = '/super_admin/control_panel',
	SuperAdminBlocklistedIpAddresses = '/super_admin/blocklisted_ip_addresses',
	SuperAdminBlocklistedEmailDomains = '/super_admin/blocklisted_email_domains',
	SuperAdminPasslistedIpAddresses = '/super_admin/passlisted_ip_addresses',
	SuperAdminScheduledPointEvents = '/super_admin/scheduled_point_events',
	SuperAdminBlocklistedCompanies = '/super_admin/blocklisted_companies',
	SuperAdminMarmonSFTP = '/super_admin/user_management_integrations/marmon_sync',
	SuperAdminKvmsOverview = '/super_admin/kvms',
	SuperAdminOneOnOneActivation = '/super_admin/kvms/one-on-one-activation',
	SuperAdminTranscriptMetrics = '/super_admin/kvms/transcript-metrics',
	SuperAdminNotificationMetrics = '/super_admin/kvms/notification-metrics',
	SuperAdminTrialConversion = '/super_admin/kvms/trial-conversion',
	SuperAdminGoalsAdoption = '/super_admin/kvms/goals-adoption',
	SuperAdminAdviceAdoption = '/super_admin/kvms/advice-adoption',
	SuperAdminOneOnOneAdoption = '/super_admin/kvms/one-on-one-adoption',
	SuperAdminDraftAssistOutcomes = '/super_admin/kvms/bizy/draft-assist-outcomes',
	SuperAdminBizyFeatureRequests = '/super_admin/bizy/feature-requests',
	SuperAdminBizyEarlyAccessRequests = '/super_admin/bizy/early-access-requests',
	SuperAdminBizyFeedback = '/super_admin/bizy/feedback',
	SuperAdminBizyConversations = '/super_admin/bizy/conversations',
	SuperAdminBizyDreaming = '/super_admin/bizy/dreaming',
	SuperAdminConversationSuggestions = '/super_admin/one_on_ones/conversation_suggestions',
	SuperAdminBizyAnalytics = '/super_admin/bizy/analytics',
	/** @deprecated Use SuperAdminBizyAnalytics `/usage` — kept for legacy links. */
	SuperAdminBizyTrends = '/super_admin/bizy/analytics/usage',
	/** @deprecated Use SuperAdminBizyAnalytics `/cost` — kept for legacy links. */
	SuperAdminBizyCosts = '/super_admin/bizy/analytics/cost',
	SuperAdminBizyAdoption = '/super_admin/bizy/adoption',
	SuperAdminBizyTopics = '/super_admin/bizy/topics',
	SuperAdminBizyTrainingConversations = '/super_admin/bizy/training_conversations',
	SuperAdminBizyTriggers = '/super_admin/bizy/triggers',
	SuperAdminDigestNewsletter = '/super_admin/digest-newsletter',
	SuperAdminVideos = '/super_admin/videos',
	SuperAdminEmail = '/super_admin/mailer/index',
	SuperAdminTesting = '/super_admin/testing',
	SuperAdminUserWorkflows = '/super_admin/testing/workflows',
	SuperAdminRewardCertificates = '/super_admin/test/reward_certificates',
	SuperAdminLogoAnalysis = '/super_admin/test/logo_analysis',
	SuperAdminAvatars = '/super_admin/test/avatar',
	SuperAdminIntercom = '/super_admin/intercom_conversations',
	SuperAdminIntegrationsHealth = '/super_admin/hris_health',
	SuperAdminLanguageFeedback = '/super_admin/language_feedbacks',
	SuperAdminBetaFeedback = '/super_admin/beta_feedbacks',
	SuperAdminAnalyticsFeedback = '/super_admin/analytics_chart_feedbacks',
	SuperAdminDonationPayouts = '/super_admin/donation_payouts',
	SuperAdminQualityBotReports = '/super_admin/bonus_quality_bot_reports',
	SuperAdminEvents = '/super_admin/events',
	SuperAdminOAuthApplications = '/super_admin/oauth-applications',
	SuperAdminPublicApiMetrics = '/super_admin/public-api/metrics',
	SuperAdminPublicApiRateLimits = '/super_admin/public-api/rate-limits',
	Integrations = '/company/settings/integrations',
	TechOps = '/tech_ops',
	TechOpsCompany = '/tech_ops/company',
	TechOpsUser = '/tech_ops/user',
}

// external pages
export enum Page {
	DesignSystem = 'https://design.bonus.ly',
	Help = 'https://help.bonus.ly/en/',
	NewFeatures = 'https://help.bonus.ly/en/articles/4076250-product-updates-and-new-features',
}
